
import React from 'react';
import { cn } from '@/lib/utils';
import { Button, ButtonProps } from '@/components/ui/button';

interface ButtonAnimationProps extends ButtonProps {
  children: React.ReactNode;
  className?: string;
  delayMs?: number;
}

const ButtonAnimation: React.FC<ButtonAnimationProps> = ({
  children,
  className,
  delayMs = 0,
  ...props
}) => {
  return (
    <Button
      className={cn(
        'overflow-hidden relative transition-all duration-300 hover:shadow-lg active:scale-95',
        'after:content-[""] after:absolute after:h-full after:w-full after:top-0 after:left-0',
        'after:bg-white/20 after:opacity-0 after:transition-all after:duration-300',
        'hover:after:opacity-100 hover:after:scale-[1.3] after:scale-[0]',
        `animate-fade-in [animation-delay:${delayMs}ms]`,
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ButtonAnimation;
